import _find from 'lodash/find';
import _flatten from 'lodash/flatten';
import _toInteger from 'lodash/toInteger';
import d3Legacy from 'd3-legacy';
import moment from 'moment';
import 'scss/cndc_gen_bar_yearly.scss';
import { getCurrentD3Locale } from 'js/helpers/dateTimeAndNumberFormatting';
var BAR_MARGIN = 3;
var PLOT_HEIGHT = 400; // const RANGE_ROUND_BANDS_SIZE = 0.1;

var Y_AXIS_LABEL_X = 10;
var Y_AXIS_LABEL_Y = -10;
var TOOLTIP_X_MARGIN = 20;
var TOOLTIP_Y_MARGIN = 15;
var TOOLTIP_SIDE_PADDING = 9;
var TOOLTIP_TOP_BOTTOM_PADDING = 7;
var TOOLTIP_TOP_MARGIN = 20;
export function initializePlot(props, a) {
  var countryID = props.countryID,
      plotID = props.plotID;
  var values = props.plot.currentState.data.values;
  if (!document.getElementById("".concat(plotID, "_graph"))) return;
  var fullDateExtent = [];
  values[0].biomass.map(function (z) {
    return fullDateExtent.push(z.x);
  }); // Fix me (API)

  var fullValueExtent = [0, d3Legacy.max(values.map(function (y) {
    var key = Object.keys(y);
    return y[key][0].y;
  }))];
  var svg = d3Legacy.select(a.refs.graphSvg);
  var range = fullDateExtent;
  props.actions.setTotalDateRange(countryID, plotID, [moment(range[0]), moment(range[range.length - 1])]);
  svg.selectAll('*').remove();
  var xScale = d3Legacy.scale.ordinal().domain(fullDateExtent).rangeRoundBands([15, PLOT_HEIGHT], 0.1); // 0.1 debe ser dinamico

  xScale.domain(fullDateExtent).rangeRoundBands([0, svg.node().getBoundingClientRect().width], 0.1); // 0.1 debe ser dinamico

  var yScale = d3Legacy.scale.linear().domain(fullValueExtent).range([PLOT_HEIGHT, 15]);
  yScale.domain(fullValueExtent).range([PLOT_HEIGHT, 15]); // ------------------------------------------------------- Eje X

  var xAxis = d3Legacy.svg.axis().scale(xScale).tickFormat(function (b) {
    return formatXAxisDate(b);
  }).orient('bottom');
  var xAxisElement = svg.append('g').attr('class', 'cosmos-axis cosmos-axis--x').attr('transform', "translate(0,".concat(PLOT_HEIGHT, ")")).call(xAxis);
  xAxis.scale(xScale);
  xAxisElement.call(xAxis); // ------------------------------------------------------- Eje Y

  var yAxis = d3Legacy.svg.axis().scale(yScale).orient('left');
  var yAxisElement = svg.append('g').attr('class', 'cosmos-axis cosmos-axis--y').attr('transform', "translate(15,0)").call(yAxis);
  var yAxisElementText = yAxisElement.append('text').attr('transform', 'rotate(-90)').attr('class', 'cosmos-axis__label').attr('x', Y_AXIS_LABEL_X).attr('y', Y_AXIS_LABEL_Y);
  yAxis.scale(yScale);
  yAxisElement.call(yAxis);
  yAxisElementText.text('MW');
  var details = {
    xScale: xScale,
    svg: svg,
    fullValueExtent: fullValueExtent,
    fullDateExtent: fullDateExtent,
    yScale: yScale,
    xAxis: xAxis,
    xAxisElement: xAxisElement,
    yAxis: yAxis,
    yAxisElement: yAxisElement,
    yAxisElementText: yAxisElementText
  };
  updateBars(details, props.plot, values, 'mw', a);
  props.actions.addEntry(props.countryID, props.plotID, 'details', details);
}

function updateBars(details, plot, values, key, a) {
  var newDetails = details;
  var xScale = details.xScale,
      svg = details.svg,
      fullValueExtent = details.fullValueExtent,
      yScale = details.yScale;

  var barWidth = _toInteger(xScale.rangeBand() / values.length);

  values.forEach(function (element, index) {
    // element.id = const key = Object.keys(y);  y[key][0]
    var identifier = Object.keys(element)[0];
    var cosmosBars = svg.selectAll(".cosmos-graph__bar.cosmos-graph__bar--".concat(identifier)).data(element[identifier]);
    var cosmosBackgroundBars = svg.selectAll(".cosmos-graph__bar-background.cosmos-graph__bar-background--".concat(identifier)).data(element[identifier]);

    var barMetadata = _find(plot.controls.grouped_types, {
      id: identifier
    });

    if (!barMetadata) return; // ---------------------------------------- colored bars

    cosmosBars.enter().append('rect').attr('class', "cosmos-graph__bar cosmos-graph__bar--".concat(identifier));
    cosmosBars.exit().remove();
    cosmosBars.style('pointer-events', 'none').attr('rx', 3).attr('ry', 3).attr('stroke', barMetadata.color).attr('fill', barMetadata.color).attr('fill-opacity', 0.3).attr('x', function (d) {
      return xScale(mapPlotDataPointToDateTime(d)) + (BAR_MARGIN + 1) + barWidth * index;
    }).attr('width', barWidth - BAR_MARGIN).attr('y', function (d) {
      return yScale(d.y);
    }).attr('height', function (d) {
      return getGraphHeight() - yScale(d.y);
    });
    cosmosBars.enter().append('rect').attr('class', "cosmos-graph__bar cosmos-graph__bar--".concat(identifier)); // ---------------------------------------- tooltip

    var tooltipNode = svg.append('g').attr('class', 'cosmos-focus-node').attr('display', 'none');
    var tooltipNodeRect = tooltipNode.append('rect').attr('rx', '5px').attr('ry', '5px').attr('class', 'cosmos-focus-node__tooltip');
    var tooltipNodeText = tooltipNode.append('text').attr('class', 'cosmos-focus-node__tooltip-text');
    newDetails.tooltipNode = tooltipNode;
    newDetails.tooltipNodeRect = tooltipNodeRect;
    newDetails.tooltipNodeText = tooltipNodeText; // ---------------------------------------- highlight bars (hover over)

    cosmosBackgroundBars.enter().append('rect').attr('class', "cosmos-graph__bar-background cosmos-graph__bar-background--".concat(identifier));
    cosmosBackgroundBars.exit().remove();
    cosmosBackgroundBars.attr('fill-opacity', 0).attr('x', function (d) {
      return xScale(mapPlotDataPointToDateTime(d)) + barWidth * index + 1;
    }).attr('width', barWidth + BAR_MARGIN).attr('y', yScale(fullValueExtent[1]) - 1).attr('height', getGraphHeight() + 1).on('mouseover', onBarMouseOverGenerator(index, barMetadata, barWidth, 'mw', newDetails)).on('mouseout', onBarMouseOutGenerator(newDetails)); // ---------------------------------------- colored bars

    cosmosBars.enter().append('rect').attr('class', "cosmos-graph__bar cosmos-graph__bar--".concat(identifier));
    cosmosBars.exit().remove();
    cosmosBars.style('pointer-events', 'none').attr('rx', 3).attr('ry', 3).attr('stroke', barMetadata.color).attr('fill', barMetadata.color).attr('fill-opacity', 0.3).attr('x', function (d) {
      return xScale(mapPlotDataPointToDateTime(d)) + (BAR_MARGIN + 1) + barWidth * index;
    }).attr('width', barWidth - BAR_MARGIN).attr('y', function (d) {
      return yScale(d.y);
    }).attr('height', function (d) {
      return getGraphHeight() - yScale(d.y);
    });
    cosmosBars.enter().append('rect').attr('class', "cosmos-graph__bar cosmos-graph__bar--".concat(identifier));
  });
}

function onBarMouseOverGenerator(barIndex, barMetadata, barWidth, key, details) {
  // hover over
  return function (d) {
    var xScale = details.xScale,
        svg = details.svg,
        fullValueExtent = details.fullValueExtent,
        yScale = details.yScale,
        tooltipNode = details.tooltipNode,
        tooltipNodeText = details.tooltipNodeText,
        tooltipNodeRect = details.tooltipNodeRect;
    var backgroundBar = d3Legacy.select(this);
    backgroundBar.attr('fill-opacity', 0.5);
    var nodePositionX = xScale(mapPlotDataPointToDateTime(d)) + barIndex * barWidth;
    var nodePositionY = yScale(fullValueExtent[1]) + TOOLTIP_TOP_MARGIN;
    tooltipNode.attr('display', null);
    tooltipNodeText.style('text-anchor', 'start').attr('x', TOOLTIP_X_MARGIN + barWidth).attr('y', TOOLTIP_Y_MARGIN).text(["".concat(barMetadata.name, ":"), _toInteger(d[key]), key].join(' '));
    var textBBox = tooltipNodeText[0][0].getBBox();

    if (nodePositionX >= getSvgWidth(svg) / 2) {
      tooltipNodeText.style('text-anchor', 'end').attr('x', -TOOLTIP_X_MARGIN);
      textBBox = tooltipNodeText[0][0].getBBox();
    }

    tooltipNodeRect.attr('stroke', barMetadata.color).attr('width', textBBox.width + TOOLTIP_SIDE_PADDING * 2).attr('height', textBBox.height + TOOLTIP_TOP_BOTTOM_PADDING * 2).attr('x', textBBox.x - TOOLTIP_SIDE_PADDING).attr('y', textBBox.y - TOOLTIP_TOP_BOTTOM_PADDING);
    tooltipNode.attr('transform', "translate(".concat(nodePositionX, ",").concat(nodePositionY, ")"));
  };
}

export function onBarMouseOutGenerator(details) {
  // clea hover over
  var tooltipNode = details.tooltipNode;
  return function () {
    var backgroundBar = d3Legacy.select(this);
    backgroundBar.attr('fill-opacity', 0);
    tooltipNode.attr('display', 'none');
  };
}
export function getSvgWidth(svg) {
  return svg.node().getBoundingClientRect().width;
}
export function getGraphHeight() {
  return PLOT_HEIGHT;
}
export function formatXAxisDate(d) {
  var date = new Date(d);
  return getCurrentD3Locale().timeFormat('%Y')(date);
}
export function mapPlotDataToAllDates(plotData) {
  return _flatten(plotData.map(mapPlotDataGroupToDataPoints)).map(mapPlotDataPointToDateTime);
}
export function mapPlotDataToAllValues(data, type) {
  return _flatten(data.map(mapPlotDataGroupToDataPoints)).map(function (dataPoint) {
    return dataPoint[type];
  });
}
export function mapPlotDataGroupToDataPoints(dataGroup) {
  return dataGroup.values;
}
export function mapPlotDataPointToDateTime(dataPoint) {
  return dataPoint.x;
}